import AutomaticContainerRow from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/parts/Content/parts/AutomaticContainerList/parts/AutomaticContainerRow'
import { AutomaticContainer } from '@/features/pos/components/Cart/parts/Overview/parts/CartItem/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface AutomaticContainerListProps {
    containers: AutomaticContainer[]
    action: 'remove' | 'restore'
    onAction: (containerId: string) => void
}

const AutomaticContainerList: FC<AutomaticContainerListProps> = ({
    containers,
    action,
    onAction,
}) => {
    return (
        <View style={styles.container}>
            {containers.map((container) => (
                <AutomaticContainerRow
                    key={container.id}
                    container={container}
                    action={action}
                    onAction={onAction}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 8,
    },
})

export default AutomaticContainerList
